class Common {
  constructor(el,opt){
    this.footerAccordionMedia = window.matchMedia('(max-width: 767px)');
    this.fixedHeaderMedia = window.matchMedia('(min-width: 768px)');
    this.fixedHeaderTicking = false;
    this.isSpDrawerOpen = false;
    this.event();
  }
  initFooterAccordion() {
    const $accordions = $('.js-accordion');
    const isSp = this.footerAccordionMedia.matches;

    $accordions.off('click.footerAccordion');

    if (!isSp) {
      $accordions.removeClass('is-active');
      $accordions.next('.sub').each(function() {
        $(this).stop(true, true).css('display', '');
      });
      
      return;
    }

    $accordions.each(function() {
      const $trigger = $(this);
      const $sub = $trigger.next('.sub');

      if ($trigger.hasClass('is-active')) {
        $sub.show();
      } else {
        $sub.hide();
      }
    });

    $accordions.on('click.footerAccordion', function() {
      const $trigger = $(this);
      $trigger.toggleClass('is-active');
      $trigger.next('.sub').slideToggle(300);
    });
  }
  initFixedHeader() {
    this.$header = $('.js-header').first();
    this.$fixedHeader = $('.js-fixed-header').first();

    if (!this.$header.length || !this.$fixedHeader.length) {
      return;
    }

    this.updateFixedHeader();
  }
  updateFixedHeader() {
    if (!this.$header || !this.$fixedHeader) {
      return;
    }

    if (!this.fixedHeaderMedia.matches) {
      this.$fixedHeader.removeClass('is-show').attr('aria-hidden', 'true').attr('inert', '');
      return;
    }

    const headerBottom = this.$header[0].getBoundingClientRect().bottom;
    const isHeaderHidden = headerBottom <= 0;

    this.$fixedHeader
      .toggleClass('is-show', isHeaderHidden)
      .attr('aria-hidden', isHeaderHidden ? 'false' : 'true');

    if (isHeaderHidden) {
      this.$fixedHeader.removeAttr('inert');
    } else {
      this.$fixedHeader.attr('inert', '');
    }
  }
  requestFixedHeaderUpdate() {
    if (this.fixedHeaderTicking) {
      return;
    }

    this.fixedHeaderTicking = true;
    window.requestAnimationFrame(() => {
      this.updateFixedHeader();
      this.fixedHeaderTicking = false;
    });
  }
  initSpDrawer() {
    this.$spDrawer = $('.js-sp-drawer').first();
    this.$spDrawerOpen = $('.js-sp-menu-open').first();

    if (!this.$spDrawer.length || !this.$spDrawerOpen.length) {
      return;
    }

    this.closeSpDrawer();

    this.$spDrawerOpen.off('click.spDrawer').on('click.spDrawer', () => {
      if (this.isSpDrawerOpen) {
        this.closeSpDrawer(true);
      } else {
        this.openSpDrawer();
      }
    });

    this.$spDrawer.off('click.spDrawerLink').on('click.spDrawerLink', 'a', () => {
      this.closeSpDrawer();
    });

    $(document).off('keydown.spDrawer').on('keydown.spDrawer', (e) => {
      if (e.key === 'Escape' && this.isSpDrawerOpen) {
        this.closeSpDrawer(true);
      }
    });
  }
  openSpDrawer() {
    if (!this.$spDrawer || !this.$spDrawer.length) {
      return;
    }

    this.isSpDrawerOpen = true;
    $('body').addClass('is-sp-drawer-open overflow-hidden');
    this.$spDrawer.addClass('is-open').attr('aria-hidden', 'false').removeAttr('inert');
    this.$spDrawerOpen.attr('aria-expanded', 'true').attr('aria-label', 'メニューを閉じる');
  }
  closeSpDrawer(shouldFocusOpen = false) {
    if (!this.$spDrawer || !this.$spDrawer.length) {
      return;
    }

    this.isSpDrawerOpen = false;
    $('body').removeClass('is-sp-drawer-open overflow-hidden');
    this.$spDrawer.removeClass('is-open').attr('aria-hidden', 'true').attr('inert', '');

    if (this.$spDrawerOpen && this.$spDrawerOpen.length) {
      this.$spDrawerOpen.attr('aria-expanded', 'false').attr('aria-label', 'メニューを開く');
      if (shouldFocusOpen) {
        this.$spDrawerOpen.trigger('focus');
      }
    }
  }
  event(){
    this.initFooterAccordion();
    this.initFixedHeader();
    this.initSpDrawer();

    let footerAccordionResizeTimer;
    $(window).on('resize', () => {
      clearTimeout(footerAccordionResizeTimer);
      footerAccordionResizeTimer = setTimeout(() => {
        this.initFooterAccordion();
        this.updateFixedHeader();
        if (this.fixedHeaderMedia.matches) {
          this.closeSpDrawer();
        }
      }, 150);
    });

    $(window).on('scroll', () => {
      this.requestFixedHeaderUpdate();
    });
  }
}
